import * as types from './user-tenants.types';
import * as constants from './user-tenants.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';
import { IUser } from '../user/user.types';

export const switchTenant = (tenantId: string): types.ISwitchTenant => ({
  type: constants.SWITCH_USER_TENANT,
  payload: { tenantId },
});

export const searchUserTenants = (): types.ISearchUserTenants => ({
  type: constants.SEARCH_USER_TENANTS,
});

export const addUserToTenant = (id: IUser['id']): types.IAddUserToTenantAction => ({
  type: constants.ADD_USER_TO_TENANT,
  payload: { id },
});

export const createTenant = (payload: types.ICreateTenantFromUserData): types.ICreateUserTenant => ({
  type: constants.CREATE_TENANT,
  payload,
});

export const storeUserTenants = generateStoreResourceAction<types.ITenant>(constants.STORE_TENANTS);
export const clearUserTenants = generateClearResourceAction(constants.CLEAR_TENANTS);
